import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchObjectService, SearchObject } from 'src/app/shared/services/search-object.service';

@Component({
  selector: 'app-tier-modal',
  templateUrl: './tier-modal.component.html',
  styleUrls: ['./tier-modal.component.scss']
})
export class TierModalComponent implements OnInit {
  searchObject: SearchObject;
  constructor(public _dialogRef: MatDialogRef<TierModalComponent>,
    private searchObjectService: SearchObjectService,
    @Inject(MAT_DIALOG_DATA) public doses: any) { }

  ngOnInit(): void {
    this.searchObject = this.searchObjectService.getSearchObject();
  }


  onNoClick(): void {
    this._dialogRef.close();
  }

  getTextForTier(tier: string) {
    return  (this.searchObjectService.isFormularyIdCheck() ? (tier == '1' ? 'Generic': 'Brand') : ('Tier ' + tier));
  }

}
